import { render, staticRenderFns } from "./CadastroEntidade.vue?vue&type=template&id=36ce6f7e"
import script from "./CadastroEntidade.vue?vue&type=script&lang=js"
export * from "./CadastroEntidade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports